import { createAction } from '@reduxjs/toolkit';

/* ACTION TYPES */
export const SHOW_PAYMENT_POPUP = 'SHOW_PAYMENT_POPUP';

// FIXME: not used
export const HIDE_PAYMENT_POPUP = 'HIDE_PAYMENT_POPUP';

export const PAYMENT_MODAL_SHOW = 'PAYMENT_MODAL_SHOW';
export const PAYMENT_MODAL_HIDE = 'PAYMENT_MODAL_HIDE';

export const SHOW_CHANGE_MAIL_SCREEN = 'SHOW_CHANGE_MAIL_SCREEN';

export const SET_EXPAND_VIEW_FOR_STRIPE = 'SET_EXPAND_VIEW_FOR_STRIPE';

export const TOGGLE_LOADER = 'TOGGLE_LOADER';
export const UPDATE_PURCHASE_FLOW = 'UPDATE_PURCHASE_FLOW';
export const SHOW_SPECIAL_OFFER = 'SHOW_SPECIAL_OFFER';
export const TOGGLE_MODAL_DISCOUNT = 'TOGGLE_MODAL_DISCOUNT';
export const MARK_DISCOUNT_SHOWN = 'MARK_DISCOUNT_SHOWN';

/* ACTIONS */
export const showPaymentPopup = createAction<undefined>(SHOW_PAYMENT_POPUP);
export const hidePaymentPopup = createAction<undefined>(HIDE_PAYMENT_POPUP);

export const showPaymentModal = createAction<Partial<{
  product: string;
  currency: string;
  price: number;
  upselPDF: boolean,
}>>(PAYMENT_MODAL_SHOW);

export const hidePaymentModal = createAction<undefined>(PAYMENT_MODAL_HIDE);

export const showChangeMailScreen = createAction<boolean>(SHOW_CHANGE_MAIL_SCREEN);
export const toggleLoader = createAction<boolean>(TOGGLE_LOADER);

export const expandViewForStripe = createAction<boolean>(SET_EXPAND_VIEW_FOR_STRIPE);

export const updatePurchaseFlow = createAction<{
  email?: string;
  url?: string;
  payment_system?: string;
  upselPDF?: boolean,
  testChat?: boolean,
}>(UPDATE_PURCHASE_FLOW);

export const showSpecialOffer = createAction<undefined>(SHOW_SPECIAL_OFFER);
export const toggleModalDiscount = createAction(TOGGLE_MODAL_DISCOUNT);
export const markDiscountShown = createAction(MARK_DISCOUNT_SHOWN);
